export function disablePhoneAutoLink(phone: string): string {
  return phone.split('').join('\u200B');
}
